import { Link, NavLink, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X, Facebook } from "lucide-react";
import { useState, useEffect } from "react";
import { useCart } from "@/context/CartContext";

const FB_URL = "https://www.facebook.com/cka22";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/about", label: "About" },
  { to: "/custom", label: "Custom Requests" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { totalItems } = useCart();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#0A0A0A]/80 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-5 md:px-10 py-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img
            src="https://customer-assets.emergentagent.com/job_indigenous-merch/artifacts/pftx9pi2_downloadfile-6.png"
            alt="CKA · Cam's Koori Art"
            className="w-12 h-12 md:w-14 md:h-14 object-contain"
            style={{
              WebkitMaskImage:
                "radial-gradient(circle at center, black 40%, rgba(0,0,0,0.6) 60%, transparent 82%)",
              maskImage:
                "radial-gradient(circle at center, black 40%, rgba(0,0,0,0.6) 60%, transparent 82%)",
            }}
          />
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm uppercase tracking-widest hover:text-[#FF4500] transition-colors ${
                  isActive ? "text-[#FF4500]" : "text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={FB_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-facebook"
            aria-label="CKA on Facebook"
            className="hidden sm:flex w-9 h-9 border border-white/20 items-center justify-center hover:bg-[#FF4500] hover:border-[#FF4500] hover:text-white transition-colors"
          >
            <Facebook className="w-4 h-4" />
          </a>
          <Link
            to="/cart"
            data-testid="nav-cart-button"
            className="relative flex items-center gap-2 border border-white/20 px-3 py-2 hover:bg-white hover:text-black transition-colors"
          >
            <ShoppingBag className="w-4 h-4" />
            <span className="text-xs uppercase tracking-widest">Cart</span>
            {totalItems > 0 && (
              <span
                data-testid="nav-cart-badge"
                className="absolute -top-2 -right-2 bg-[#FF4500] text-white text-xs w-5 h-5 flex items-center justify-center font-bold"
              >
                {totalItems}
              </span>
            )}
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2 border border-white/20"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden border-t border-white/10 bg-[#0A0A0A]">
          <div className="flex flex-col p-5 gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-lg font-display tracking-wider hover:text-[#FF4500]"
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={FB_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="nav-mobile-facebook"
              className="text-lg font-display tracking-wider hover:text-[#FF4500] flex items-center gap-3 pt-2 border-t border-white/10 mt-2"
            >
              <Facebook className="w-5 h-5" /> Facebook
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
